import { Injectable } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";
import { TemplateService } from '../../core/poll-templates/template.service';
import { EssErrorService } from 'ngx-essentia';
import { InvitationThemeConfig, invitationThemeMap } from '../../core/poll-templates/poll-config/invitation-themes/invitation-theme.config';
import { HeaderService } from '../poll-header/header.service';
import { GenericThemeConfig, genericThemeMap } from '../../core/poll-templates/poll-config/generic-themes/generic-theme.config';


@Injectable({
    providedIn: 'root'
})

export class HeaderOrTemplateService {
    constructor(
        private logger: LoggerService,
        private templateService: TemplateService,
        private headerService: HeaderService,
        private errorService: EssErrorService
    ) {
    }

    public getHeaderOrTemplateAttribute(attributeKeyLevel: string): string | boolean | string[] {
        const headerAttribute = this.headerService.headerClass[attributeKeyLevel]
        if (headerAttribute) return headerAttribute
        return this.templateService.getConfigAttribute('defaultSettings', attributeKeyLevel)
    }

    public getFormToUse(): string {
        const formtoUseFromHeader = this.headerService.headerClass.formToUse
        if (formtoUseFromHeader) return formtoUseFromHeader
        return <string>this.templateService.getConfigAttribute('general', 'formToUse')

    }


}
